var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccesWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: 98,
    height: 98.0001
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(4px)",
      clipPath: "url(#bgblur_0_5102_34182_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_5102_34182)",
    "data-figma-bg-blur-radius": 8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 41.0001C17 23.3269 31.3269 9 49 9C66.6731 9 81 23.3269 81 41.0001C81 58.6732 66.6731 73.0001 49 73.0001C31.3269 73.0001 17 58.6732 17 41.0001Z",
    fill: "#11A811",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 41.0001C17 23.3269 31.3269 9 49 9C66.6731 9 81 23.3269 81 41.0001C81 58.6732 66.6731 73.0001 49 73.0001C31.3269 73.0001 17 58.6732 17 41.0001Z",
    fill: "url(#paint0_linear_5102_34182)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 8.5C66.9492 8.5 81.5 23.0508 81.5 41C81.5 58.9493 66.9493 73.5 49 73.5C31.0507 73.5 16.5 58.9493 16.5 41C16.5 23.0508 31.0508 8.5 49 8.5Z",
    stroke: "#BBF9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.333 41.5467V35.4534C36.333 33.8667 37.3063 32.4533 38.7863 31.8933L49.373 27.8933C51.0263 27.2666 52.7997 28.4933 52.7997 30.2667V35.3333",
    fill: "#DCFDDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.333 41.5467V35.4534C36.333 33.8667 37.3063 32.4533 38.7863 31.8933L49.373 27.8933C51.0263 27.2666 52.7997 28.4933 52.7997 30.2667V35.3333",
    stroke: "#F7FEF6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.053 43.0667C56.493 43.6134 56.173 44.4001 56.253 45.2401C56.373 46.6801 57.693 47.7334 59.133 47.7334H61.6663V49.3201C61.6663 52.0801 59.413 54.3334 56.653 54.3334H43.173C43.5863 53.9868 43.9463 53.5601 44.2263 53.0801C44.7197 52.2801 44.9997 51.3334 44.9997 50.3334C44.9997 47.3868 42.613 45.0001 39.6663 45.0001C38.413 45.0001 37.253 45.4401 36.333 46.1734V40.3467C36.333 37.5867 38.5863 35.3334 41.3463 35.3334H56.653C59.413 35.3334 61.6663 37.5867 61.6663 40.3467V42.2667H58.973C58.2263 42.2667 57.5463 42.5601 57.053 43.0667Z",
    fill: "#DCFDDB",
    stroke: "#F7FEF6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0781 43.6269V46.3737C63.0781 47.107 62.4914 47.707 61.7447 47.7336H59.1314C57.6914 47.7336 56.3714 46.6803 56.2514 45.2403C56.1714 44.4003 56.4914 43.6136 57.0514 43.0669C57.5447 42.5603 58.2247 42.267 58.9714 42.267H61.7447C62.4914 42.2936 63.0781 42.8936 63.0781 43.6269Z",
    stroke: "#F7FEF6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.333 41H51.6663",
    stroke: "#F7FEF6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9997 50.3335C44.9997 51.3335 44.7197 52.2801 44.2263 53.0801C43.9463 53.5602 43.5863 53.9868 43.173 54.3335C42.2397 55.1735 41.013 55.6668 39.6663 55.6668C37.7197 55.6668 36.0263 54.6268 35.1063 53.0801C34.613 52.2801 34.333 51.3335 34.333 50.3335C34.333 48.6535 35.1063 47.1468 36.333 46.1735C37.253 45.4401 38.413 45.0001 39.6663 45.0001C42.613 45.0001 44.9997 47.3868 44.9997 50.3335Z",
    stroke: "#F7FEF6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5879 50.3328L38.9079 51.6528L41.7479 49.0261",
    stroke: "#F7FEF6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_5102_34182",
    x: 0,
    y: 0,
    width: 98,
    height: 98.0001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 16,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_5102_34182"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5102_34182"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_5102_34182"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.733333 0 0 0 0 0.976471 0 0 0 0 0.72549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5102_34182",
    result: "effect2_dropShadow_5102_34182"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_5102_34182",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_5102_34182_clip_path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 41.0001C17 23.3269 31.3269 9 49 9C66.6731 9 81 23.3269 81 41.0001C81 58.6732 66.6731 73.0001 49 73.0001C31.3269 73.0001 17 58.6732 17 41.0001Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5102_34182",
    x1: 17,
    y1: 9,
    x2: 81.0001,
    y2: 73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#1DCB1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#46E345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccesWallet);
export default __webpack_public_path__ + "static/media/succes-wallet.87031294f63de1358785b44641f8f674.svg";
export { ForwardRef as ReactComponent };